export const roleRoutes = {
  list: "",
  create: "new",
  details: ":id",
  edit: ":id/edit",
} as const;
